import ResourceService from "./resource.service";

class CohortAnalysisService extends ResourceService {
  static get resource() {
    return "admin/analytics/cohort";
  }
}

export default CohortAnalysisService;